<template>
  <div class="flexd">
    <div class="layout-content" style="background: transparent; margin: 0px">
      <!-- <div v-if="list.length"> -->
      <div v-if="list1.length">
        <el-table
          ref="multipleTable"
          :data="list1"
          tooltip-effect="dark"
          stripe
          style="width: 100%"
          :header-cell-style="{ 'background-color': '#f8f8f9' }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="名称" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.name }}</template>
          </el-table-column>
          <el-table-column label="类型" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.type }}</template>
          </el-table-column>
          <el-table-column label="语言" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.languageType }}</template>
          </el-table-column>
          <el-table-column
            prop="displayOrder"
            label="显示顺序"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="是否启用" show-overflow-tooltip>
            <template slot-scope="scope"
              ><el-switch
                v-model="scope.row.isEnable"
                active-color="#d13119"
                inactive-color="#dcdfe6"
                @change="(status) => setAudit(scope.row, status)"
              >
              </el-switch
            ></template>
          </el-table-column>
          <el-table-column label="操作" show-overflow-tooltip>
            <template slot-scope="scope">
              <span
                style="color: #1727ff; cursor: pointer"
                @click="detailNumbers(scope.row)"
                >编辑</span
              >
              <span style="margin: 0 10px">|</span>
              <!-- <span
                style="color: #d13119; cursor: pointer"
                @click="del(scope.row)"
                >删除</span
              > -->
              <el-popover
                :ref="`popover-${scope.$index}`"
                trigger="click"
                visible-arrow="false"
                placement="top"
              >
                <p style="text-align: right; margin-bottom: 15px">
                  您确定要跳过吗？
                </p>
                <div style="margin: 0 auto; text-align: center">
                  <el-button
                    size="mini"
                    type="text"
                    @click="
                      scope._self.$refs[`popover-${scope.$index}`].doClose()
                    "
                    >取消</el-button
                  >
                  <el-button type="primary" size="mini" @click="del(scope)"
                    >确定</el-button
                  >
                </div>
                <span style="color: #d13119; cursor: pointer" slot="reference"
                  >删除</span
                >
              </el-popover>
            </template>
          </el-table-column>
        </el-table>

        <!-- <div style="margin-top: 20px">
          <el-button @click="batch()">批量设置语言</el-button>
        </div> -->
      </div>
      <div class="u-empty" v-else>暂无数据</div>
    </div>
    <el-dialog
      title="编辑商品分组"
      :visible.sync="rejectModel"
      width="500px"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="名称" prop="name">
          <el-input
            type="text"
            size="small"
            v-model="ruleForm.name"
            placeholder="请输入名称"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="类别" prop="type">
          <el-radio v-model="ruleForm.type" label="固定费用">固定费用</el-radio>
          <el-radio v-model="ruleForm.type" label="线上">线上 </el-radio>
          <el-radio v-model="ruleForm.type" label="线下">线下 </el-radio>
        </el-form-item>
        <el-form-item label="语言" prop="languageType">
          <el-radio v-model="ruleForm.languageType" label="中文">中文</el-radio>
          <el-radio v-model="ruleForm.languageType" label="英文"
            >英文
          </el-radio>
        </el-form-item>
        <el-form-item
          label=" 显示顺序"
          prop="displayOrder"
          class="displayOrders"
        >
          <el-input
            type="text"
            size="small"
            placeholder="请输入顺序"
            v-model="ruleForm.displayOrder"
            autocomplete="off"
          ></el-input>
          <span>数字越小显示越靠前</span>
        </el-form-item>

        <el-form-item label="是否开启" prop="isEnable">
          <el-switch
            v-model="ruleForm.isEnable"
            active-color="#d13119"
            inactive-color="#dcdfe6"
          >
          </el-switch>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <Button type="primary" @click="handleSubmitReject('ruleForm')"
          >确定</Button
        >
        <Button @click="rejectModel = false" style="margin-left: 10px"
          >取消</Button
        >
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "areaPage",
  data() {
    return {
      list: [],
      list1: [],
      list2: [],
      item: "",
      currentIndex: 1,
      currentName: "",
      rejectModel: false,
      rejectModel1: false,
      rejectModel2: false,
      id: "",
      selectId: [],
      ruleForm: {
        type: "",
        name: "",
        languageType: "",
        isEnable: true,
        displayOrder: "",
      },
      listType: ["展位", "广告", "会议", "租凭"],
      rules: {
        name: [{ required: true, message: "请输入名称" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        languageType: [
          { required: true, message: "请选择语言", trigger: "change" },
        ],
        displayOrder: [
          { required: true, message: "请输入顺序", trigger: "change" },
        ],
      },
    };
  },
  components: {
    // exhibitionCarYes,
    // exhibitionCarNo
  },
  computed: {
    ...mapGetters({
      exhibition: "loginModule/getExhibition",
      exhibitionInfo: "hostSetModule/getHostExhibition",
      hostExhibition: "hostSetModule/getHostExhibition",
      exhibitionId: "hostSetModule/getHostExhibition",
    }),
  },
  created() {
    document.title = "商品分组管理";
    this.init1();
  },
  methods: {
    ...mapActions({
      getExhibitionCommodity: "hostManage/getExhibitionCommodity",
      getExhibitionCommodityKind: "hostManage/getExhibitionCommodityKind",
      getCommodities: "hostManage/getCommodities",
      areaIsEnable: "hostManage/areaIsEnable",
      getAllArea: "hostManage/getAllArea",
      batchSettleReportType: "hostManage/batchSettleReportType",
      groupIsEnable: "hostManage/groupIsEnable",
      getExhibitionCommodityGroup: "hostManage/getExhibitionCommodityGroup",
      addGroup: "hostManage/addGroup",
      deleteGroup: "hostManage/deleteGroup",
      updateGroup: "hostManage/updateGroup",
    }),
    // 转换日期格式
    async init1() {
      let opt = {
        exhibitionId: this.exhibitionId.id,
      };

      let proData2 = await this.getExhibitionCommodityGroup(opt);
      this.list1 = proData2;
    },
    async lists(id) {
      let opt1 = {
        exhibitionId: this.exhibitionId.id,
        kindId: id,
      };
      let proData1 = await this.getCommodities(opt1);
      this.list = proData1;
    },
    handleSelectionChange(value) {
      console.log(value);

      this.selectId = [];
      value.forEach((e) => {
        this.selectId.push(e.id);
      });
    },
    batch() {
      if (this.selectId.length == 0) {
        this.$message.error("请先选择修改项！");
        return;
      }
      this.rejectModel = true;
    },
    // 修改订单数
    async detailNumbers(item) {
      this.rejectModel = true;
      if (item) {
        this.item = item;
        this.ruleForm.name = item.name;
        this.ruleForm.type = item.type;
        this.ruleForm.languageType = item.languageType;
        this.ruleForm.isEnable = item.isEnable;
        this.ruleForm.displayOrder = item.displayOrder;
      } else {
        this.item = "";
        this.ruleForm.name = "";
        this.ruleForm.type = "";
        this.ruleForm.languageType = "";
        this.ruleForm.isEnable = true;
        this.ruleForm.displayOrder = "";
      }
    },
    async del(item) {
      console.log(item);
      let res = await this.deleteGroup({
        id: item.row.id,
      });
      console.log(res);
      if (res && res.successed) {
        this.$Message.success("删除成功");
        this.rejectModel = false;
      }
      this.init1();
      this.$refs[`popover-${item.$index}`].doClose();
    },
    async setAudit(item, status) {
      let res = await this.groupIsEnable({
        id: item.id,
        isEnable: status,
      });
      if (res && res.successed) {
        this.$Message.success("设置成功");
        this.rejectModel = false;
      }
      this.init1();
    },
    async handleSubmitReject(formName) {
      let valid = await this.validForm(formName);
      if (!valid) return;
      let opt = {
        exhibitionId: this.exhibitionId.id,
        id: this.item ? this.item.id : "",
        name: this.ruleForm.name,
        type: this.ruleForm.type,
        languageType: this.ruleForm.languageType,
        isEnable: this.ruleForm.isEnable,
        displayOrder: this.ruleForm.displayOrder,
      };
      if (!this.item) {
        delete opt.id;
      }
      if (this.item) {
        const res = await this.updateGroup(opt);
        if (res && res.successed) {
          this.$Message.success("修改成功");
          this.rejectModel = false;
        }
      } else {
        const res = await this.addGroup(opt);
        if (res && res.successed) {
          this.$Message.success("设置成功");
          this.rejectModel = false;
        }
      }

      this.init1();
    },
    handleClose() {
      this.rejectModel = false;
      this.$refs["ruleForm"].resetFields();
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    clickIndex(item, index) {
      this.currentName = item.name;
      this.lists(item.id);
      this.currentIndex = index + 1;
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          resolve(valid);
        });
      });
    },
  },
};
</script>
  
<style scoped lang="scss">
.reds {
  color: #d13119 !important;
}
.required {
  color: red;
  margin-right: 4px;
}
.header-tabs {
  // display: flex;
  position: relative;
}
.searchPro {
  position: absolute;
  right: 24px;
  top: 0;
}
.catalogue {
  .header-tool {
    min-height: 90px;
  }

  &-content {
    min-width: 1000px;
    margin: 24px;
    padding: 40px;
    min-height: 500px;
    padding-bottom: 190px;
  }
}

.cib {
  min-width: 1000px;
  margin: 30px;
  padding: 40px;
  min-height: 500px;
  background: rgb(23, 39, 255);
  padding-bottom: 190px;
}

.spanClass {
  margin-left: 4px;
  margin-right: 4px;
}
.ivu-table-wrapper {
  // padding-bottom: 20px!important;
  overflow: visible !important;
}
.deleteClass {
  color: #f78989;
  // cursor:pointer;
}

.lookClass {
  color: #d13119;
  cursor: pointer;
}

.marLeft {
  margin-left: 15px;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #d13119 !important;
  border-color: #d13119 !important;
}

.flexd {
  display: flex;
}
.leftList {
  width: 200px;
  background-color: #fff;
  border-right: 1px solid #dcdfe6;
  div {
    padding-left: 15px;
    line-height: 47px;
    border-bottom: 1px solid #dcdfe6;
    color: #000;
  }
}
.layout-content {
  flex: 1;
}
::v-deep .el-select {
  width: 100%;
}
::v-deep .displayOrders .el-input {
  width: 150px;
  margin-right: 15px;
}
</style>
  